import sensors from 'sa-sdk-javascript'

import { isSuccess } from '@/httpRequest'
import { getUserInfo } from '@/httpRequest/modules/user/userInfo'

export const handleLoginTrack = async () => {
  const resp = await getUserInfo()
  if (resp && isSuccess(resp)) {
    const userData = resp.data

    sensors.login(userData.id)

    sensors.track('user_login', {
      gender: userData.gender,
      register_type: userData.register_type,
      created_at: userData.created_at,
      author_id: userData.author_id
    })
  }
}

export const handleContentViewTrack = (chapterInfo: unknown) => {
  sensors.track('content_view', {
    ...(chapterInfo as object)
  })

  window.ttq?.track('ViewContent', {
    contents: [
      {
        content_id: (chapterInfo as Record<string, string>).resource_id
      }
    ]
  })
}

export const handleShelfClickTrack = () => {
  sensors.track('shelf_click')
}

export const handleSearchInputTrack = () => {
  sensors.track('search_input')
}

export const handleSearchKeywordTrack = (
  keyword: string,
  result_count: number,
  search_type: string
) => {
  sensors.track('search_keyword', {
    keyword,
    result_count,
    search_type
  })
}

export const handleImGroupOpenTrack = (
  resource_type: string,
  resource_id: string,
  tag: string,
  im_group_code: string
) => {
  sensors.track('imgroup_open', {
    resource_type,
    resource_id,
    tag,
    im_group_code
  })
}

export const handleImClickTrack = (from: string, contact_uid: string) => {
  sensors.track('im_click', {
    from,
    contact_uid
  })
}

export const handleTopUpTrack = (
  channel: string,
  resource_type: string,
  resource_id: string
) => {
  sensors.track('top_up', {
    from: window.location.href,
    channel,
    resource_type,
    resource_id
  })

  window.ttq?.track('InitiateCheckout', {
    contents: [
      {
        content_id: resource_id
      }
    ]
  })
}

export const handlePublishClickTrack = () => {
  sensors.track('publish_click')
}

export const handleFeaturedClickTrack = (
  featured_position: number,
  resource_type: string,
  resource_id: string
) => {
  sensors.track('featured_click', {
    featured_position,
    resource_type,
    resource_id
  })
}

export const handleDetailViewTrack = (
  resource_type: string,
  resource_id: string,
  tag?: string
) => {
  sensors.track('detail_view', {
    resource_type,
    resource_id,
    tag
  })
}

export const handleClickMessage = () => {
  sensors.track('click_message')
}

export const handleClickMessageList = () => {
  sensors.track('click_message_list')
}

export const handleClickGroupList = () => {
  sensors.track('click_group_list')
}

export const handleContactMeClick = () => {
  sensors.track('Contact_me_click')
}

export const handleClickFollow = (
  follow_id: string,
  be_follow_id: string,
  from_follow: string
) => {
  sensors.track('click_follow', {
    follow_id,
    be_follow_id,
    from_follow
  })
}

export const handleClickCreateGroupChat = () => {
  sensors.track('click_create_group_chat')
}

export const handleClickSendMessage = (
  session_id: string,
  session_type: number,
  message_type: number,
  sender_id: string
) => {
  sensors.track('click_send_message', {
    session_id,
    session_type,
    message_type,
    sender_id
  })
}

export const handleSendSuccess = (
  session_id: string,
  session_type: number,
  message_type: number,
  sender_id: string
) => {
  sensors.track('send_success', {
    session_id,
    session_type,
    message_type,
    sender_id
  })
}
